import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { SkapaInlineMessage, SkapaTokens } from '@inter-ikea-guida/skapa';
import { useIsMetricMeasures } from '../../hooks/useIsMetricMeasures';
import { getFormState } from '../../store/app/selectors';
import { getTranslation } from '../../store/i18n/selectors';
import { SLIDING } from '../../utils';
import { FormattedMeasurement } from '../common/FormattedMeasurement';
const StyledInlineMessage = styled.div `
  margin-bottom: ${props => (props.$hasMarginBottom ? SkapaTokens.space150 : 0)};
`;
export const InlineMessage = ({ hasMarginBottom }) => {
    const form = useSelector(getFormState);
    const translate = useSelector(getTranslation);
    const useMetricsMeasures = useIsMetricMeasures();
    const height = form.door_type === SLIDING ? parseInt(form.size_height) + 4 : parseInt(form.size_height) + 1;
    const bodyMessage = (_jsxs(_Fragment, { children: [translate('guid01QpMess'), ' ', _jsx(FormattedMeasurement, { cm: height, toInches: !useMetricsMeasures })] }));
    return (_jsx(StyledInlineMessage, { "data-testid": 'quiz-inline-message', "$hasMarginBottom": hasMarginBottom, children: _jsx(SkapaInlineMessage, { subtle: true, body: bodyMessage, ssrIcon: InformationCircle }) }));
};
//# sourceMappingURL=QuizInlineMessage.js.map